// Ejemplo de ReferenciaSelector modificado:
import React from 'react';
import PropTypes from 'prop-types';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftSelect from 'components/SoftSelect';

const ReferenciaSelector = ({ selectedReferencia, setSelectedReferencia }) => {
  // Define las opciones con un valor numérico (por ejemplo, TERRESTRE=1, MARÍTIMO=2, AÉREO=3)
  const referenciaOptions = [
    { value: 'Factura', label: 'Factura' },
    { value: 'Numero orden', label: 'Numero orden' },
    { value: 'Packing', label: 'Packing' },
    { value: 'Tracking', label: 'Tracking' },
  ];

  return (
    <SoftBox>
      <SoftTypography variant="caption" fontWeight="bold" color="text">
        Tipo de Referencia
      </SoftTypography>
      <SoftSelect
        options={referenciaOptions}
        value={referenciaOptions.find(option => option.value === selectedReferencia)}
        onChange={(option) => setSelectedReferencia(option ? option.value : null)}
        placeholder="Seleccione un tipo de referencia"
      />
    </SoftBox>
  );
};

ReferenciaSelector.propTypes = {
    selectedReferencia: PropTypes.string, // Ahora se espera una cadena
    setSelectedReferencia: PropTypes.func.isRequired,
  };  

export default ReferenciaSelector;
